import { gql } from '@apollo/client'

export const CONTENT_MARKS = gql`
  query contentMarks(
    $groupId: String!
    $moduleInstanceId: String!
  ) {
    contentMarks(
      groupId: $groupId
      moduleInstanceId: $moduleInstanceId
    ) {
      groupId
      moduleInstanceId
      contentType
      contentId
    }
  }
`
